import { SxProps } from '@mui/material';
import theme from '../../../../theme';

export const styles: Record<string, SxProps> = {
  mobileStepper: {
    transition: 'all 0.15s ease-in',
    '& .MuiMobileStepper-dot': {
      backgroundColor: theme.palette.common.white,
      opacity: '20%',
    },
    '& .MuiMobileStepper-dotActive': {
      backgroundColor: theme.palette.common.white,
      opacity: '100%',
    },
  },
  iconButton: {
    bgcolor: 'common.white',
    p: 2,
    transition: 'all 0.15s ease-in',
    '&:hover': {
      bgcolor: 'common.white',
    },
    '&.Mui-disabled': {
      bgcolor: 'common.white',
      opacity: '10%',
    },
  },
};
